export const iconFontAwesomeHumanitarianSackDollar = (
	<i className="fa-solid fa-sack-dollar"></i>
);
